import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import { inject, observer, setDocumentTitle, setUidToken } from 'src/helper/devTools.js'
import {
  closeWebViewPage,
  copyNew,
  jumpToUser,
  setTabBar,
  hiddenBackButton,
} from 'src/helper/webviewFun.js'
import { history } from 'src/core/router'
import Message from 'src/component/Message'
import LoadingComp from 'src/component/LoadingComp'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import hybridRouter from 'src/core/hybrid-router'
import { getlangV2, setlang } from 'src/helper/getlang'
import { isRussiaHost } from 'src/helper/tool'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.storeHobiHost = this.props.store.register('app/hobiHost')
  }

  state = {
    uid: 0,
    lang: langM.ar,
    language: 'ar',
    hostInfo: {},
    presidentInfo: {},
    countryIcon: '',
    // medalsIcon: [],
    hedinTabar: false,
    systemPhone: 'android',
    rubyOpen: 0,
    showEmpty: false,
    lodConf: true,
    listRootHeight: 5,
    hostHybrid: config.hostHybrid,
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language, langM)
    // lang 文字对象
    // language 语言种类 (zh/ar/en/tr)
    let uid = await setUidToken(this.props.location.query)
    let { accesstoken } = await localstorage.get('userInfo')
    this.setState({
      lang: setlang(language, langM),
      language: language,
      uid: uid,
      accesstoken: accesstoken || '',
    })

    try {
      // let obj = { tr: 'Ajans Sistemi', ar: "نقابة", en: "Agency" }
      setTabBar('1')
      setDocumentTitle(this.state.lang.title + '.')
    } catch (error) {
      this.refs.msg.show(`${error}`)
    }
    this.RunOnStart(uid)
  }
  componentDidMount() {
    let g = navigator.userAgent.toLowerCase().search(/lm-/i)
    let a = document.querySelector('.trade-union')
    let c = ((window.screen.height - a.clientHeight - (g > 10 ? 66 : 44)) * 2) / 100
    this.setState({
      listRootHeight: c,
      hostHybrid: isRussiaHost() ? config.hostHybridRu : config.hostHybrid,
    })
  }

  // async componentWillUnmount() {
  // localstorage.remove('thHostGuidId')
  // localstorage.remove('hostGuidIdInfo')
  // }
  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    setDocumentTitle(this.state.lang.hostTitle)
    // try {
    // let b = await localstorage.get('thHostGuidId')
    let b = this.storeHobiHost.thHostGuidId
    let info = this.storeHobiHost.hostGuidIdInfo
    // let c = b/1
    if (parseInt(b) > 0 && info.admin_info && info.country_icon) {
      // let info = await localstorage.get('hostGuidIdInfo')
      // await this.setState({
      //     hostInfo: info,
      //     presidentInfo: info.admin_info,
      //     medalsIcon: info.admin_info.medalsIcon || [],
      //     tradeUnionAtv: info && info.cover ? info.cover : info.admin_info.avatarurl,
      //     countryIcon: info.country_icon ? info.country_icon : info.admin_info.countryIcon,
      //     showEmpty: false,
      //     lodConf: false,
      //     guildId: parseInt(b)
      // })
      // await localstorage.remove('thHostGuidId')
      // await localstorage.remove('hostGuidIdInfo')
    } else {
      this.getGuildId(uid)
    }
    // } catch (error) {
    //     this.refs.msg.show(`${error}`)
    // }
  }
  getGuildId = async (uid) => {
    let d = await this.storeHobiHost.GetUserInfoWeb()
    // let res = await http.post('/web/MyAccountInfo', { uid })
    console.log('url ddd', d)
    if (d && d.guildId > 0) {
      hiddenBackButton('0')
      this.storeHobiHost.getTiInfo(d.guildId)
      // await this.getTiInfo(res.res.guildId)
      // this.setState({ guildId: res.res.guildId })
      this.setState({ showEmpty: false, lodConf: false })
      // if (uid == '973220') {
      //     this.refs.msg.show(`You're GuildId ${res.res.guildId}`)
      // }
    } else {
      // this.setState({ showEmpty: true, lodConf: false })
      // this.refs.msg.show(`You're not unionized`)
      // hiddenBackButton('1')
      let url = this.state.hostHybrid + hybridRouter.list + '?isClose=1'
      if (/^\d.*\d$/.test(window.location.host)) {
        url = `${url}&language=${this.state.language}&uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`
      }

      console.log('url0', url)
      window.location.replace(url)
    }
  }

  // getTiInfo = async (guild_id) => {
  //     let res = await http.post('/web/guild/info', { guild_id })
  //     if (res.code == 0) {
  //         let info = res.res
  //         this.setState({
  //             hostInfo: info,
  //             presidentInfo: info.admin_info,
  //             medalsIcon: info.admin_info.medalsIcon,
  //             tradeUnionAtv: info && info.cover ? info.cover : info.admin_info.avatarurl,
  //             countryIcon: info.country_icon ? info.country_icon : info.admin_info.countryIcon,
  //         })
  //         await localstorage.remove('thHostGuidId')
  //         await localstorage.remove('hostGuidIdInfo')
  //     } else {
  //         if (uid == '973220') {
  //             this.refs.msg.show(`后端反馈错误了 ${res.msg} `)
  //         }
  //     }
  // }

  goToHostList = () => {
    let { hostGuidIdInfo } = this.storeHobiHost.data
    let hostInfo = hostGuidIdInfo || {}
    // eslint-disable-next-line no-unused-vars
    let { language, uid } = this.state
    // console.log(111, hostInfo, hostInfo.admin_uid)
    if (hostInfo && hostInfo.admin_uid && hostInfo.admin_uid == uid) {
      let url = this.state.hostHybrid + hybridRouter.member
      if (/^\d.*\d$/.test(window.location.host)) {
        url = `${url}?language=${language}&uid=${uid}&accesstoken=${this.state.accesstoken}`
      }
      // history.push(`/app/host-member?guid=${hostInfo.id}&language=${language}`)
      console.log('url1', url)
      window.location.href = url
    }
  }

  goToHybrid = (path) => {
    let url = this.state.hostHybrid + hybridRouter.apply
    if (/^\d.*\d$/.test(window.location.host)) {
      url = `${url}?language=${this.state.language}&uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`
    }
    console.log('url2', url)
    window.location.href = url
  }

  getLvBg = (e) => {
    let srt = ''
    if (e == 0) {
      srt = '0'
    } else if (e > 0 && e <= 9) {
      srt = '09'
    } else if (e > 9 && e <= 19) {
      srt = '1019'
    } else if (e > 19 && e <= 29) {
      srt = '2029'
    } else if (e > 29 && e <= 39) {
      srt = '3039'
    } else if (e > 39 && e <= 49) {
      srt = '4049'
    } else if (e > 49 && e <= 59) {
      srt = '5059'
    } else if (e > 59 && e <= 69) {
      srt = '6069'
    } else if (e > 69 && e <= 79) {
      srt = '7079'
    } else if (e > 79 && e <= 89) {
      srt = '8089'
    } else if (e > 89 && e <= 99) {
      srt = '9099'
    } else if (e == 100) {
      srt = '100'
    }
    return srt
  }

  goPage = async (e) => {
    let { language, uid, accesstoken } = this.state //, hostInfo, guildId
    // await localstorage.set('thHostGuidId', guildId)
    // await localstorage.set('hostGuidIdInfo', JSON.stringify(hostInfo))
    if (e == 0) {
      history.push(`/app/datacenter?language=${language}&uid=${uid}&accesstoken=${accesstoken}`)
    } else if (e == 1) {
      history.push(
        `/app/hobiMemberCoins?language=${language}&uid=${uid}&accesstoken=${accesstoken}`
      )
    } else if (e == 4) {
      history.push(`/app/invite-member?language=${language}&uid=${uid}&accesstoken=${accesstoken}`)
    }
  }

  render() {
    // onClick={() => this.teseClik()}
    let { lodConf, showEmpty, listRootHeight, uid, lang, language } = this.state
    let { hostGuidIdInfo } = this.storeHobiHost.data
    let hostInfo = hostGuidIdInfo || {}
    console.log('hostInfo', hostInfo)
    let presidentInfo = hostGuidIdInfo.admin_info || {}
    let { avatarurl, countryIcon } = presidentInfo
    return (
      <div id="dasscrollBody" className={`hobi-host ${language == 'ar' && 'arlang'} `}>
        {showEmpty && <div className="inempty-showd"></div>}
        <div className="trade-union">
          {<div style={{ height: '0.84rem', width: '100%', clear: 'both' }}></div>}
          <img className="fil-img" src={hostGuidIdInfo.cover || avatarurl}></img>
          <div className="close-webview-root">
            <img
              src="/img/app/newhost/bif_cb_icon.png"
              style={{ transform: `${language == 'ar' ? 'rotate(180deg)' : ''}` }}
              onClick={() => closeWebViewPage()}
            ></img>
            <div className="dome-title">{lang.hostTitle}</div>
          </div>
          <div className="trade-info">
            <img
              className="trade-atv"
              style={{
                marginRight: `${language == 'ar' ? '0' : '0.24rem'}`,
                marginLeft: `${language == 'ar' ? '0.24rem' : '0'}`,
              }}
              src={avatarurl}
            ></img>
            <div className="info">
              <div className="name">
                <div className="name-text">{hostInfo.name || ''}</div>
                <div className="line"></div>
                {countryIcon && <img className="cont-icon" src={countryIcon} />}
                <div className="con-name">{hostInfo.country_code || ''}</div>
              </div>
              <div className="host-num" onClick={() => this.goToHostList()}>
                <div>
                  {`${lang.menberTitle} : `}
                  {!hostInfo.member_number
                    ? '0'
                    : hostInfo.member_number > 99
                      ? '99+'
                      : hostInfo.member_number}
                </div>
                {true && <img className="more-pipos" src="/img/app/newhost/host_member.png" />}
              </div>
              <div className="id-new" onClick={() => copyNew(lang.copySuc, hostInfo.id + '')}>
                <span className="id-num">ID: {hostInfo.gid || ''}</span>
                <img className="copy-icon" src="/img/app/newhost/copy-icon.png"></img>
              </div>
            </div>
          </div>
          <div className="president">
            {presidentInfo && (presidentInfo.avatarurl || presidentInfo.avatar_url) && (
              <img
                className={`presidentatv ${language == 'ar' ? 'president-atv-ar' : 'president-atv'}`}
                src={presidentInfo.avatarurl || presidentInfo.avatar_url || ''}
                onClick={() => jumpToUser(presidentInfo.uid)}
              ></img>
            )}
            <div className="president-info">
              <div className="name">
                <span>{presidentInfo.nickname || ''}</span>
                {presidentInfo && presidentInfo.gender == 2 && (
                  <img className="user-sex" src="/img/app/newhost/woman_icon.png" />
                )}
                {presidentInfo && presidentInfo.gender == 1 && (
                  <img className="user-sex" src="/img/app/newhost/boy_icon.png" />
                )}
                {presidentInfo.countryIcon && (
                  <img className="cont-countryIcon" src={presidentInfo.countryIcon} />
                )}
              </div>
              <div className="president-id">
                <span>ID: {presidentInfo.duid || ''}</span>
              </div>
              <div className="president-medal">
                {presidentInfo.nobleUrl && (
                  <img className="medal-item" src={presidentInfo.nobleUrl} />
                )}
                {presidentInfo.wealthLv > 0 && (
                  <div className="lv-item">
                    <img
                      className="lv-bg-img"
                      src={`/img/app/newhost/wealthLv/icon_wealth_${this.getLvBg(presidentInfo.wealthLv)}@3x.png`}
                    />
                    <div className="lv-num">{presidentInfo.wealthLv}</div>
                  </div>
                )}
                {presidentInfo.charmLv > 0 && (
                  <div className="lv-item">
                    <img
                      className="lv-bg-img"
                      src={`/img/app/newhost/charm/icon_charm_${this.getLvBg(presidentInfo.charmLv)}@2x.png`}
                    />
                    <div className="lv-num">{presidentInfo.charmLv}</div>
                  </div>
                )}
                {/* {false && medalsIcon && medalsIcon.length > 0 && medalsIcon.map((item, index) => (<img className='medal-item' key={index} src={item} />))} */}
              </div>
            </div>
          </div>
          <div style={{ height: '0.44rem', width: '6rem' }}></div>
        </div>
        <div className="host-list-root" style={{ height: `${listRootHeight}rem` }}>
          <div className="data-conter" onClick={() => this.goPage(0)}>
            <div className="left">
              <img className="is-icon" src="/img/app/newhost/datta_banner.png"></img>
              <div className="title">{lang.datecenterText}</div>
            </div>
            <img
              className="right"
              src="/img/app/newhost/data_center_go_icon.png"
              style={{ transform: `${language == 'ar' ? 'rotate(180deg)' : ''}` }}
            ></img>
          </div>
          {hostInfo.admin_uid == uid && (
            <div className="data-conter" onClick={() => this.goPage(1)}>
              <div className="left">
                <img className="is-icon" src="/img/app/newhost/host_coin_page.png"></img>
                <div className="title">{lang.navTexg}</div>
              </div>
              <img
                className="right"
                src="/img/app/newhost/data_center_go_icon.png"
                style={{ transform: `${language == 'ar' ? 'rotate(180deg)' : ''}` }}
              ></img>
            </div>
          )}
          {/* 会长和管理员才有权限 */}
          {[2, 3].includes(hostInfo.role) && (
            <div className="data-conter" onClick={() => this.goToHybrid()}>
              <div className="left">
                <div className="is-icon">
                  <img className="is-icon" src="/img/app/newhost/icon-member@2x.webp"></img>
                  {hostInfo.apply_total > 0 && <div className="data-conter-number"></div>}
                </div>
                <div className="title">{lang.memberApply}</div>
              </div>
              <img
                className="right"
                src="/img/app/newhost/data_center_go_icon.png"
                style={{ transform: `${language === 'ar' ? 'rotate(180deg)' : ''}` }}
              ></img>
            </div>
          )}
        </div>
        {/* 会长和管理员才有权限 */}
        {[2, 3].includes(hostInfo.role) && (
          <div className="invite-user" onClick={() => this.goPage(4)}>
            {lang.inviteText}
          </div>
        )}
        <Message ref="msg" desc={this.state.desc} />
        <LoadingComp show={lodConf} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/hobiHost/index.js